<template>
  <div
    v-bind:class="{
      strategiesPortTableHeight1: showCalculator,
      strategiesPortTableHeight2: !showCalculator,
    }"
  >
    <div class="row f-row mt-1 bdr-b bdr-t justify-content-center">
      <div class="col col-11">
        <table
          class="table table-sm table-responsive table-borderless real_time_table"
          style="width: 100%; z-index: 100000; padding-bottom: 0!important; margin-bottom: 0!important;"
        >
          <tbody>
            <tr v-for="(item, index) in portfolioComposition" :key="index">
              <td class="text-left" style="width: 80%">{{ item.name }}:</td>
              <td style="width: 20%; color: var(--textinactive)">
                <v-progress-circular
                  :value="item.perc"
                  :rotate="5"
                  :color="colorExpo(colorTheme)"
                  :size="25"
                  :width="3"
                >
                </v-progress-circular>
                {{ (item.perc / 100) | percentageFormat }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row f-row mt-1 results-header">
      <div class="col col-8 analytics_results text-left">
        {{ baseCurrency["isCurrency"] ? "Hedged notional" : "Hedged quantity" }}
        <span style="color: var(--textactive)"
          >({{ baseCurrency["foreign"] }})</span
        >
      </div>
      <div
        class="col col-4 text-right"
        style="font-size: 0.9rem; color: var(--textactive)"
      >
        {{ notionalTotal | numFormat }}
      </div>
    </div>

    <div class="row f-row mt-2 results-header">
      <div class="col col-12 analytics_results text-left">
        Choose Output Type: Resulting Rates or P&L
      </div>
    </div>

    <div class="row f-row mt-1 results-header">
      <div class="col col-12 analytics_results text-center">
        <label
          :for="'tableResults'"
          class="toggle__button_nav"
          style="height: 100%; width:100%!important; margin:auto!important;"
          :class="{ actives: selectedTableBoolean }"
        >
          <input
            type="checkbox"
            @click="onUserTableChange"
            :id="'tableResults'"
            v-model="selectedTableBoolean"
          />
          <span class="toggle__switch_nav" style="width:100%;">
            <div class="row f-row justify-content-center">
              <div
                class="col col-6 txt-label-primary-2 text-center"
                style="font-size: 0.75rem!important;"
              >
                Price
              </div>
              <div
                class="col col-6 txt-label-primary-2 text-center"
                style="font-size: 0.75rem!important;"
              >
                Profit and Loss
              </div>
            </div>
          </span>
        </label>
      </div>
    </div>

    <div class="row f-row mt-2 results-header" v-if="!selectedTableBoolean">
      <div class="col col-12 analytics_results text-left">
        {{ baseCurrency["isCurrency"] ? "Rate" : "Price" }}
        <span style="color: var(--textactive)"
          >({{ baseCurrency["rate"] }})</span
        >
      </div>
    </div>
    <div
      class="row f-row mt-1 results-header bdr-b"
      v-if="!selectedTableBoolean"
    >
      <div class="col col-12 analytics_results mb-1">
        <table class="table table-borderless table-sm table-sims">
          <tbody>
            <tr>
              <th style="width: 30%"></th>
              <th style="width: 35%" class="table-center-borders text-center">
                <i class="fa fa-minus" style="color:var(--symmetry)"></i>
                Unhedged
              </th>
              <th style="width: 35%" class="text-center">
                <div class="circle-hedge inh">o</div>
                Hedged
              </th>
            </tr>
            <tr>
              <th>
                <div class="sim-table-txt fnt-sm">VaR {{ confidenceVaR }}%</div>
              </th>
              <td class="table-center-borders">
                <div
                  class="sim-table-txt"
                  style="color: var(--symmetry-h)!important;"
                >
                  <i
                    class="fa fa-long-arrow-up mr-auto clr-inctv"
                    v-if="selectedPosition === 1"
                  ></i>
                  <i class="fa fa-long-arrow-down mr-auto clr-inctv" v-else></i>
                  <div class="inh">{{ portfolioStats.var | priceFormat }}</div>
                </div>
              </td>
              <td style="color: var(--hedge-h)!important;">
                <div class="sim-table-txt">
                  <i
                    class="fa fa-long-arrow-up mr-auto clr-inctv"
                    v-if="selectedPosition === 1"
                  ></i>
                  <i class="fa fa-long-arrow-down mr-auto clr-inctv" v-else></i>
                  <div class="inh">{{ portfolioStats.varH | priceFormat }}</div>
                </div>
              </td>
            </tr>
            <tr>
              <th><div class="sim-table-txt-2 fnt-sm">Average</div></th>
              <td
                class="table-center-borders"
                style="color: var(--symmetry-h)!important;"
              >
                <div class="sim-table-txt-2">
                  <span class="mr-auto"></span>
                  {{ portfolioStats.ave | priceFormat }}
                </div>
              </td>
              <td style="color: var(--hedge-h)!important;">
                <div
                  class="sim-table-txt-2"
                  v-bind:class="[!selectedOptimBoolean ? 'bdr-hedge' : '']"
                >
                  <span class="mr-auto"></span>
                  {{ portfolioStats.aveH | priceFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <div class="sim-table-txt fnt-sm">
                  Best {{ confidenceVaR }}%
                </div>
              </th>
              <td class="table-center-borders">
                <div
                  class="sim-table-txt"
                  style="color: var(--symmetry-h)!important;"
                >
                  <i
                    class="fa fa-long-arrow-down mr-auto clr-inctv"
                    v-if="selectedPosition === 1"
                  ></i>
                  <i class="fa fa-long-arrow-up mr-auto clr-inctv" v-else></i>
                  <div class="inh">{{ portfolioStats.best | priceFormat }}</div>
                </div>
              </td>
              <td style="color: var(--hedge-h)!important;">
                <div
                  class="sim-table-txt"
                  v-bind:class="[selectedOptimBoolean ? 'bdr-hedge' : '']"
                >
                  <i
                    class="fa fa-long-arrow-down mr-auto clr-inctv"
                    v-if="selectedPosition === 1"
                  ></i>
                  <i class="fa fa-long-arrow-up mr-auto clr-inctv" v-else></i>
                  <div class="inh">
                    {{ portfolioStats.bestH | priceFormat }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row f-row mt-1 results-header" v-if="selectedTableBoolean">
      <div class="col col-12 analytics_results text-left">
        Profit and Loss
        <span style="color: var(--textactive)"
          >({{ baseCurrency["base"] }})</span
        >
      </div>
    </div>
    <div
      class="row f-row mt-1 results-header bdr-b"
      v-if="selectedTableBoolean"
    >
      <div class="col col-12 analytics_results mb-1">
        <table class="table table-borderless table-sm table-sims">
          <tbody>
            <tr>
              <th style="width: 30%"></th>
              <th style="width: 35%" class="table-center-borders text-center">
                <i class="fa fa-minus" style="color:var(--symmetry)"></i>
                Unhedged
              </th>
              <th style="width: 35%" class="text-center">
                <div class="circle-hedge inh">o</div>
                Hedged
              </th>
            </tr>
            <tr>
              <th>
                <div class="sim-table-txt fnt-sm">VaR {{ confidenceVaR }}%</div>
              </th>
              <td class="table-center-borders">
                <div
                  class="sim-table-txt"
                  style="color: var(--symmetry-h)!important;"
                >
                  <i
                    class="fa fa-long-arrow-up mr-auto clr-inctv"
                    v-if="selectedPosition === 1"
                  ></i>
                  <i class="fa fa-long-arrow-down mr-auto clr-inctv" v-else></i>
                  <div class="inh">{{ portfolioStats.varPnl | numFormat }}</div>
                </div>
              </td>
              <td style="color: var(--hedge-h)!important;">
                <div class="sim-table-txt">
                  <i
                    class="fa fa-long-arrow-up mr-auto clr-inctv"
                    v-if="selectedPosition === 1"
                  ></i>
                  <i class="fa fa-long-arrow-down mr-auto clr-inctv" v-else></i>
                  <div class="inh">
                    {{ portfolioStats.varPnlH | numFormat }}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th><div class="sim-table-txt-2 fnt-sm">Average</div></th>
              <td
                class="table-center-borders"
                style="color: var(--symmetry-h)!important;"
              >
                <div class="sim-table-txt-2">
                  <span class="mr-auto"></span>
                  {{ portfolioStats.avePnl | numFormat }}
                </div>
              </td>
              <td style="color: var(--hedge-h)!important;">
                <div
                  class="sim-table-txt-2"
                  v-bind:class="[!selectedOptimBoolean ? 'bdr-hedge' : '']"
                >
                  <span class="mr-auto"></span>
                  {{ portfolioStats.avePnlH | numFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <div class="sim-table-txt fnt-sm">
                  Best {{ confidenceVaR }}%
                </div>
              </th>
              <td class="table-center-borders">
                <div
                  class="sim-table-txt"
                  style="color: var(--symmetry-h)!important;"
                >
                  <i
                    class="fa fa-long-arrow-down mr-auto clr-inctv"
                    v-if="selectedPosition === 1"
                  ></i>
                  <i class="fa fa-long-arrow-up mr-auto clr-inctv" v-else></i>
                  <div class="inh">
                    {{ portfolioStats.bestPnl | numFormat }}
                  </div>
                </div>
              </td>
              <td style="color: var(--hedge-h)!important;">
                <div
                  class="sim-table-txt"
                  v-bind:class="[selectedOptimBoolean ? 'bdr-hedge' : '']"
                >
                  <i
                    class="fa fa-long-arrow-down mr-auto clr-inctv"
                    v-if="selectedPosition === 1"
                  ></i>
                  <i class="fa fa-long-arrow-up mr-auto clr-inctv" v-else></i>
                  <div class="inh">
                    {{ portfolioStats.bestPnlH | numFormat }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row f-row mt-1 results-header">
      <div class="col col-12 analytics_results text-left">
        Choose Optimization Method:
      </div>
    </div>
    <div class="row f-row mt-1 results-header">
      <div class="col col-12 analytics_results text-center">
        <label
          :for="'optimSelect'"
          class="toggle__button_rt"
          style="height: 100%; width:100%!important; margin:auto!important;"
          :class="{ actives: selectedOptimBoolean }"
        >
          <input
            type="checkbox"
            @click="onUserOptimChange"
            :id="'optimSelect'"
            v-model="selectedOptimBoolean"
          />
          <span class="toggle__switch_rt" style="width:100%;">
            <div class="row f-row justify-content-center">
              <div
                class="col col-6 txt-label-primary-2 text-center"
                style="font-size: 0.75rem!important;"
              >
                Expected Value
              </div>
              <div
                class="col col-6 txt-label-primary-2 text-center"
                style="font-size: 0.75rem!important;"
              >
                Best Cases
              </div>
            </div>
          </span>
        </label>
      </div>
    </div>

    <div class="row f-row mt-2 results-header" style="height: 26px!important;">
      <div class="col col-5 analytics_results text-left">
        Confidence (%):
      </div>
      <div class="col col-cx analytics_results mr-2">
        <Slider
          v-model="confidenceAux"
          :step="1"
          :min="60"
          :max="99"
          @change="onUserConfidence"
        />
      </div>
      <div class="col col-2 analytics_results">
        <input
          v-model.number.lazy="confidenceAux"
          placeholder="%"
          min="60"
          max="99"
          class="custom-input ddown-hedge"
          step="1"
          @change="onUserConfidence"
        />
      </div>
    </div>
    <div class="row f-row results-header mt-1">
      <div class="col col-12 updated-at-box">
        1 out of {{ (1 / (1 - confidenceAux / 100)) | numFormat }} times
      </div>
    </div>

    <div class="row f-row mt-1 results-header">
      <div class="col col-12 analytics_results text-left">
        Choose Your Restrictions:
        <i
          v-show="costRestrictionCheck || varRestrictionCheck"
          class="fa fa-warning warn-my-data ml-3"
          @mouseover="onHoverWarning(true)"
          @mouseleave="onHoverWarning(false)"
        ></i>
        <div class="warning-optimize-div text-center" v-if="showWarningDiv">
          Restrictions not met
        </div>
      </div>
    </div>
    <div class="row f-row mt-1 results-header bdr-b">
      <div class="col col-12 analytics_results mb-1">
        <table class="table table-borderless table-sm table-sims">
          <tbody>
            <tr>
              <th style="width: 60%">
                <div class="sim-table-txt fnt-sm">
                  VaR {{ confidenceVaR }}%
                  {{ portfolioStats.varPnl >= 0 ? "above" : "below" }} (rate):
                </div>
              </th>
              <td style="color: var(--hedge-h)!important; width: 40%">
                <InputNumber
                  :borderYellow="varRestrictionCheck"
                  :tableFormat="true"
                  v-model="varRestriction"
                />
              </td>
            </tr>
            <tr>
              <th>
                <div class="sim-table-txt fnt-sm">Cost under:</div>
              </th>
              <td style="color: var(--hedge-h)!important;">
                <InputNumber
                  :borderYellow="costRestrictionCheck"
                  :tableFormat="true"
                  v-model="costRestriction"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row f-row bdr-b">
      <div class="col col-12">
        <button
          type="button"
          style="font-size: 1rem!important;"
          class="btn btn-strat-blue"
          v-on:click="onUserOptimize"
        >
          <span v-if="showLoadingOptimizing" class="text-left mr-2">
            <QSLoading
              :isLoading="showLoadingSpot"
              :size="20"
              :colorTheme="true"
            />
          </span>
          <span v-if="showLoadingOptimizing">Optimization in progress</span>
          <span v-else>Optimize</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { colorExpo } from "@/_core/_helpers/_parametric_tools";
import { format } from "d3";
import InputNumber from "@/components/InputNumber";
import QSLoading from "@/components/QSLoading.vue";
import Slider from "primevue/slider";

export default {
  name: "SimulationsTable",
  components: {
    InputNumber,
    QSLoading,
    Slider,
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    showCalculator: { required: true },
    selectedStrategyLegs: { required: true, default: 1 },
    showLoadingOptimizing: { required: true, type: Boolean, default: false },
    portfolioStats: {
      required: true,
      default: function() {
        return {
          var: 0,
          ave: 0,
          best: 0,
          varPnl: 0,
          avePnl: 0,
          bestPnl: 0,
          varH: 0,
          aveH: 0,
          bestH: 0,
          varPnlH: 0,
          avePnlH: 0,
          bestPnlH: 0,
        };
      },
    },
    portfolioCost: { required: true, default: 0 },
    portfolioComposition: { required: true, default: () => [] },
    baseCurrency: { required: true, type: Object },
    confidence: { required: true },
    asset: { required: false, default: "currencies" },
    notionalTotal: { required: true, default: 0 },
    selectedPosition: { required: true, default: 1 },
  },
  data() {
    return {
      colorExpo: colorExpo,
      confidenceAux: 0,
      confidenceVaR: 0,
      selectTable: "RATE",
      selectOptim: "AVE",
      varRestriction: 0,
      costRestriction: 0,
      showWarningDiv: false,
    };
  },
  computed: {
    costRestrictionCheck() {
      return this.portfolioCost > this.costRestriction * 1.001;
    },
    varRestrictionCheck() {
      return (
        this.selectedPosition * this.varRestriction +
          this.selectedPosition * this.varRestriction * 0.0001 <
        this.selectedPosition * this.portfolioStats.varH
      );
    },
    valueAtRisk() {
      return this.portfolioStats.var;
    },
    selectedTableBoolean: {
      get() {
        return this.selectTable === "PNL";
      },
      set() {
        return false;
      },
    },
    selectedOptimBoolean: {
      get() {
        return this.selectOptim === "BEST";
      },
      set() {
        return false;
      },
    },
  },
  filters: {
    numFormat: function(val) {
      return val === null || !isFinite(val) || val === 0
        ? "-"
        : Math.abs(val) > 1000000000000
        ? format(",.2f")(val / 1000000000000) + "T"
        : Math.abs(val) > 10000000
        ? format(",.0f")(val / 1000000) + "M"
        : format(",.0f")(val);
    },
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.4r")(val);
    },
    percentageFormat: function(val) {
      return format(",.1%")(val);
    },
  },
  mounted() {
    this.confidenceAux = this.confidence;
    this.confidenceVaR =
      Math.round(10 * (100 - (100 - this.confidence) / 2)) / 10;
    this.varRestriction =
      this.varRestriction === 0 ? this.portfolioStats.var : this.varRestriction;
  },
  watch: {
    confidence(val) {
      this.confidenceAux = val;
      this.confidenceVaR =
        Math.round(10 * (100 - (100 - this.confidence) / 2)) / 10;
    },
    valueAtRisk() {
      this.varRestriction =
        this.varRestriction === 0
          ? this.portfolioStats.var
          : this.varRestriction;
    },
  },
  methods: {
    onUserConfidence(val) {
      this.$emit("eventOnUserConfidence", val);
    },
    onUserTableChange() {
      this.selectTable = this.selectTable === "PNL" ? "RATE" : "PNL";
    },
    onUserOptimChange() {
      this.selectOptim = this.selectOptim === "BEST" ? "AVE" : "BEST";
    },
    onUserOptimize() {
      let args = {
        optimization_type: this.selectOptim,
        var_restriction: this.varRestriction,
        cost_restriction: this.costRestriction,
      };
      this.$emit("eventOnUserOptimize", args);
    },
    onHoverWarning(val) {
      this.showWarningDiv = val;
    },
  },
};
</script>

<style scoped>
.toggle__button_rt .toggle__switch_rt::after,
.toggle__button_rt .toggle__switch_rt::before {
  content: "Expected Value";
  font-size: 0.75rem !important;
  padding: 0 !important;
}
.actives .toggle__switch_rt::before,
.actives .toggle__switch_rt::after {
  content: "Best Cases";
}
.toggle__button_nav .toggle__switch_nav::after,
.toggle__button_nav .toggle__switch_nav::before {
  content: "Price";
  font-size: 0.75rem !important;
  padding: 0 !important;
}
.actives .toggle__switch_nav::before,
.actives .toggle__switch_nav::after {
  content: "Profit and Loss";
}
</style>
